import axios from "axios";

const getApi = async (url, headers) => {
  try {
    if (url) {
      const response = await axios.get(url, headers);
      if (response?.status === 200) {
        return response;
      } else {
        return { msg: "Something went wrong" };
      }
    }
  } catch (err) {
    return err;
  }
};

const postApi = async (url, payload = {}, headers) => {
  try {
    if (url && payload) {
      const response = await axios.post(url, payload, headers);
      if (response?.status === 200) {
        return response;
      } else {
        return { msg: "Something went wrong" };
      }
    }
  } catch (err) {
    console.log("ERR - POST API", err);
  }
};

export { getApi, postApi };
